import { useEffect, useState } from "react";
import { createElement, Fragment } from "react";
import { api } from "./api";
import { SITE_SCHEMA } from "./siteSchema";

const LS_KEY = "mastofa_site_content_v1";
let cache = null;
let inflight = null;
const listeners = new Set();

try {
  const raw = localStorage.getItem(LS_KEY);
  if (raw) cache = JSON.parse(raw);
} catch {
  cache = null;
}

function load() {
  if (inflight) return inflight;
  inflight = api("/site/content")
    .then((d) => {
      cache = d || {};
      try { localStorage.setItem(LS_KEY, JSON.stringify(cache)); } catch { /* ignore */ }
      listeners.forEach((l) => l(cache));
    })
    .catch(() => {})
    .finally(() => { inflight = null; });
  return inflight;
}

export function invalidateSiteContent() {
  cache = null;
  try { localStorage.removeItem(LS_KEY); } catch { /* ignore */ }
}

export function defaultOf(page, key) {
  const p = SITE_SCHEMA[page];
  if (!p) return undefined;
  const [sec, fld] = key.split(".");
  const s = p.sections.find((x) => x.key === sec);
  const f = s?.fields.find((x) => x.key === fld);
  return f?.default;
}

export function useSiteContent(page) {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    load();
    return () => listeners.delete(setData);
  }, []);
  const over = (data && data[page]) || {};
  const raw = (k) => {
    const v = over[k];
    return v === undefined || v === null || v === "" ? undefined : v;
  };
  const t = (k) => raw(k) ?? defaultOf(page, k) ?? "";
  const list = (k) => {
    const v = over[k];
    return Array.isArray(v) && v.length ? v : defaultOf(page, k) || [];
  };
  return { t, list, raw, ready: !!data };
}

// "*teks*" -> <Tag>teks</Tag>, "\n" -> <br/>
export function rich(text, Tag = "span", props = {}) {
  const parts = String(text || "").split(/(\*[^*]+\*)/g).filter(Boolean);
  return createElement(
    Fragment,
    null,
    ...parts.flatMap((p, i) => {
      if (p.startsWith("*") && p.endsWith("*")) return [createElement(Tag, { key: i, ...props }, p.slice(1, -1))];
      const lines = p.split("\n");
      return lines.flatMap((ln, j) => (j === 0 ? [ln] : [createElement("br", { key: `${i}-${j}` }), ln]));
    }),
  );
}

export const splitList = (s) => String(s || "").split(/[,\n]/).map((x) => x.trim()).filter(Boolean);
